

export default {
    name: "CvSelectorItem",
    props: {
        cv: {
            type: Object,
            default: function () {
                return {
                    _id: 0,
                    userId: 0,
                    name: "",
                    typeId: 0,
                }
            }
        },
        selectCvId: {
            type: Number,
            default: 0,
        }
    },
    computed: {
        type() {
            return this.cv.typeId===1 ? "在线简历" : "文件简历"
        },
        isSelected() {
            return this.selectCvId === this.cv._id
        }
    },
    methods: {

    }

}
